import { createRoot } from 'react-dom/client';
import { configureHoneybadger, notifyCaughtRenderError } from './Honeybadger';
import { App } from './components/App';
import './index.css';

configureHoneybadger();

createRoot(document.getElementById('root') as HTMLElement, {
  onCaughtError: notifyCaughtRenderError,
}).render(<App />);
